<template>
  <button
  test-id="sav-button"
  class="inline-block px-3 py-1 font-normal leading-normal text-center text-white no-underline whitespace-no-wrap align-middle bg-gray-900 border rounded select-none hover:bg-gray-900"
  :class="classSrc"
  @click="buttonClicked()"
  :disabled="disabled"
  >
    <slot></slot>
  </button>
</template>

<script>
  export default {
    props: {
      classSrc: {
        type: String,
        required: false
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },

    computed: {
      hasDefaultSlot () {
        return !!this.$slots.default
      }
    },

    methods: {
      buttonClicked() {
        this.$emit('click')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/SavButton.vue